import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphyEnrollmentListComponent } from './graphy-enrollment-list/graphy-enrollment-list.component';
import { GraphyLearnerListComponent } from './graphy-learner-list/graphy-learner-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ArchwizardModule } from 'angular-archwizard';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EnrolmentRoutingModule } from '../enrolment/enrolment-routing.module';
import { GraphyAdminRoutingModule } from './graphy-admin-routing.module';

@NgModule({
  declarations: [
    GraphyEnrollmentListComponent,
    GraphyLearnerListComponent
  ],
  imports: [
    CommonModule,
    GraphyAdminRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    ArchwizardModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    MatSlideToggleModule
  ],
  exports: [
    GraphyEnrollmentListComponent,
    GraphyLearnerListComponent
  ]
})
export class GraphyAdminModule { } 